import { createApp } from "vue";
import App from "./App.vue";
import router from "../../router";
import store from "../../store";

import WatsonComponentsGlobal from "@/components/watson/WatsonComponentsGlobal";
import { loadEnv } from "@/utils/env";

async function initApp() {
  await loadEnv();
  const app = createApp(App);
  app.use(store).use(router).use(WatsonComponentsGlobal);
  app.mount("#app-main");
}

initApp();
